<template>
  <b-container class="play-game text-center">
    <b-row class="notifications w-100">
      <b-col>
        <!-- Cantes de línea -->
        <b-alert
          dismissible
          v-model="lineClaims[idx]"
          variant="success"
          v-for="(lineClaim, idx) in game.lineClaims"
          :key="'line-'+idx"
        >
          <span v-if="lineClaim.userId === currentUser.uid">¡Has cantado línea!</span>
          <span v-if="lineClaim.userId != currentUser.uid">¡Han cantado línea!</span>
        </b-alert>
        <b-alert
          dismissible
          v-model="failedLineClaim"
          variant="danger"
        >
          ¡Tu línea es incorrecta!
        </b-alert>

        <!-- Cantes de bingo -->
        <b-alert
          dismissible
          v-model="bingoClaims[idx]"
          variant="success"
          v-for="(bingoClaim, idx) in game.bingoClaims"
          :key="'bingo-'+idx"
        >
          <span v-if="bingoClaim.userId === currentUser.uid">¡Has cantado bingo!</span>
          <span v-if="bingoClaim.userId != currentUser.uid">¡Han cantado bingo!</span>
        </b-alert>
        <b-alert
          dismissible
          v-model="failedBingoClaim"
          variant="danger"
        >
          Tu Bingo es incorrecto!
        </b-alert>
      </b-col>
    </b-row>
    <b-row no-gutters class="cards" align-h="center">
      <b-col md="6">
        <div class="card-content" v-for="card in myCards" :key="card.id">
          <div class="card-info-header d-flex justify-content-between">
            <span class="card-info">Cartón N.º {{card.number}}</span>
            <span class="card-info">Serie {{ card.serie }}</span>
          </div>
          <table class="card-table">
            <tr v-for="(row, rowId) in card.numbers" :key="rowId">
              <td v-for="(number, numberId) in row" :key="numberId" v-bind:class="{empty: !number}">
                <span @click="toggleMark" v-if="number">{{ number }}</span>
              </td>
            </tr>
          </table>
        </div>
      </b-col>
      <b-col md="6">
        <table class="card-table pool">
          <tr v-for="c in 9" :key="c">
            <td v-for="f in 10" :key="f">
              <span :class="{marked: game.numbers.indexOf(10*(c-1) + f) > -1}">{{ 10*(c-1) + f }}</span>
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
    <b-row class="info w-100" align-v="center">
      <b-col sm="12" align-v="center">
        <span v-if="invertedNumbers.length" class="ball last" align-v="center">{{ invertedNumbers[0] }}</span>
        <span class="ball" v-for="(number, idx) in invertedNumbers.slice(1,5)" :key="idx">{{ number }}</span>
      </b-col>
      <b-col sm="12" class="text-center">
        <b-button class="w-40" @click="claimLine" v-if="game.lineClaims.length === 0 || game.lineClaims[0].number === invertedNumbers[0]" :disabled="haveIClaimed(game.lineClaims)">¡LÍNEA!</b-button>
        <b-button class="w-40" @click="claimBingo" v-if="game.lineClaims.length != 0 && game.lineClaims[0].number != invertedNumbers[0]" :disabled="haveIClaimed(game.bingoClaims)">¡BINGO!</b-button>
        <b-button class="w-50" @click="nextNumber" v-if="game.userId === currentUser.uid" variant="light" :disabled="game.numbers.length >= 90 || game.bingoClaims.length > 0">SACAR BOLA</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "play-game",
  data() {
    return {
      myCards: [],
      showDismissibleAlert: true,
      lineClaims: Array.from({ length: 100 }, () => true),
      bingoClaims: Array.from({ length: 100 }, () => true),
      failedLineClaim: false,
      failedBingoClaim: false,
      series: []
    };
  },
  computed: {
    ...mapState(['currentUser', 'game', 'socketConnected']),
    invertedNumbers() {
      var numbers = [];
      for (var i = this.game.numbers.length - 1; i >= 0; i--) {
        numbers.push(this.game.numbers[i]);
      }
      return numbers;
    }
  },
  watch: {
    socketConnected: {
      handler(connected) {
        if (connected) {
          console.log("Restored connection with sockets server");
          this.$socket.emit('joinGame', this.$route.params.gameId);
        } else {
          console.log("Disconnected from sockets server");
        }
      }
    },
    currentUser: {
      handler(user) {
        this.updateTickets(this.game, user);
      }
    },
    game: {
      handler(game) {
        this.updateTickets(game, this.currentUser);
      },
      deep: true
    }
  },
  mounted() {
    this.$socket.emit('joinGame', this.$route.params.gameId);
  },
  beforeDestroy() {
    this.$socket.emit('leaveGame', this.$route.params.gameId);
  },
  methods: {
    async updateTickets(game, user) {
      if (this.myCards.length === 0) {
        let myTicketIds = [];
        game.assignedTickets.filter((assignment) => {
          return assignment.userId == user.uid;
        })
        .forEach(assignment => {
          myTicketIds.push(assignment.ticketId);
        });
        try {
          let res = await this.$http.get(`${process.env.VUE_APP_API_URL}/tickets`, {
            params: {
              ticketIds: myTicketIds.join(",")
            }
          });
          this.myCards = res.data
        } catch (error) {
          console.error("Cannot get tickets", error);
        }
      }
    },
    haveIClaimed(claims) {
      return claims.filter(claim => claim.userId === this.currentUser.uid).length > 0
    },
    toggleMark(evt) {
      evt.target.classList.toggle("marked")
    },
    claimLine() {
      let lineValidation = false;
      let cardId;
      this.myCards.forEach(card => {
        for (let line = 0; line < 3; line++) {
          let numbers = card.numbers[line].filter(space => space);
          if (numbers.every(number => this.game.numbers.indexOf(number) > -1)) {
            lineValidation = true;
            cardId = card.id;
          }
        }
      })
      if (lineValidation) {
        this.failedLineClaim = false;
        let claim = {
          type: "lineClaims",
          gameId: this.$route.params.gameId,
          userId: this.currentUser.uid,
          ticketId: cardId,
          number: this.game.numbers[0]
        }
        try {
          this.$http.post(`${process.env.VUE_APP_API_URL}/claim`, { claim });
        } catch (error) {
          console.error("Cannot claim line", error);
        }
      } else {
        this.failedLineClaim = true;
      }
    },
    claimBingo() {
      let bingoValidation = false;
      let cardId;
      this.myCards.forEach(card => {
        let cardValidation = [false, false, false];
        for (let line = 0; line < cardValidation.length; line++) {
          let numbers = card.numbers[line].filter(space => space);
          if (numbers.every(number => this.game.numbers.indexOf(number) > -1)) {
            cardValidation[line] = true;
            cardId = card.id;
          }
        }
        if (cardValidation.every(line => line === true)) {
          bingoValidation = true;
        }
      })
      if (bingoValidation) {
        this.failedBingoClaim = false;
        let claim = {
          type: "bingoClaims",
          gameId: this.$route.params.gameId,
          userId: this.currentUser.uid,
          ticketId: cardId,
          number: this.game.numbers[0]
        }
        try {
          this.$http.post(`${process.env.VUE_APP_API_URL}/claim`, { claim });
        } catch (error) {
          console.error("Cannot claim bingo", error);
        }
      } else {
        this.failedBingoClaim = true;
      }
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    nextNumber() {
      this.$socket.emit('draw', this.$route.params.gameId);
    },
    excludeFirst(a) {
      return a.filter((element, index) => {
        if (index != 0) {
         return true; 
        }
      })
    },
    getSerie(id) {
      let serie = {
        id: '',
        number: ''
      }
      return this.series.filter((serie) => serie.id === id)[0] || serie;
    }
  }
};
</script>

<style lang="scss" scoped>
.notifications {
  position: fixed;
  top: 70px;
  left: 15px;
  z-index: 100;
}
.play-game {
  padding-bottom: 200px;
}
.info {
  padding-top: 15px;
  padding-bottom: 20px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  margin: 0;
  background-color: var(--primary);
  box-shadow: 9px 0 9px 0 rgba(153, 153, 153, .32);
  button {
    margin: 0 5px;
  }
}
.ball {
  display: inline-block;
  font-weight: 600;
  line-height: 38px;
  width: 38px;
  height: 38px;
  border-radius: 19px;
  box-shadow: 0 0 21px 0 #00a0dd, inset 0 1px 8px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
  margin: 0 5px 15px 0;
}
.ball.last {
  font-size: 35px;
  line-height: 74px;
  width: 74px;
  height: 74px;
  border-radius: 37px;
}
.pool {
  margin-top: 50px;
}
@media only screen and (min-width: 768px) {
  .pool {
    top: 50%;
    left: 50%;
    transform: translate(10%, -200px);
    margin: 0 auto;
    position: fixed;
  }
}
</style>